import { StaticInterface } from '../../../helpers/static-interface';
import TpxSocialLinksUtils from './social-links.utils';

export interface ITpxShareBlockUtils {
}

export interface IStaticTpxShareBlockUtils {
  new (...args: any[]): ITpxShareBlockUtils;
  init(scope?: HTMLElement): void;
}

/**
 * Social links utilities
 * @class
 */
export default class TpxShareBlockUtils implements StaticInterface<IStaticTpxShareBlockUtils, typeof TpxShareBlockUtils> {
  #copySection: HTMLElement | null;
  #element: HTMLElement;

  /**
   * @constructor
   * @param {HTMLElement} element The navigation bar root element
   */
  constructor(element: HTMLElement) {
    this.#element = element;
    this.#copySection = this.#element?.querySelector('.m-share-block__copy');

    if (this.#copySection) {
      navigator?.permissions?.query({ name: "clipboard-write" as PermissionName })?.then(() => {
        this.#element.classList.add('m-share-block--can-copy');
      });
    }
  }

  /**
   * Creates new instances of TpxShareBlockUtils for each `.m-share-block` element,
   * and adds the necessary logic and event listeners to support native sharing and coping of link
   */
  static init(scope?: HTMLElement) {
    const shareBlocks: Element[] = [...(scope || document).getElementsByClassName('m-share-block')];
    shareBlocks.forEach(shareBlock => {
      new TpxShareBlockUtils(shareBlock as HTMLElement);
      TpxSocialLinksUtils.init(shareBlock as HTMLElement);
    });
  }
}